import React from 'react';

import { Card } from '../../shared'
import Small from '../../photos/5x10.png'
import Medium from '../../photos/10x10.png'
import Large from '../../photos/10x15.png'


import css from './StorageTips.module.scss'

const StorageTips = () => {
  return (
    <div className={css.storageTips}>
      <Card>
        <div className={css.center}>
          <table className={css.table}>
            <thead>
              <tr>
                <th className={css.tableHead}>Unit Size</th>
                <th className={`${css.tableHead} ${css.optional}`}>How to Visualize</th>
                <th className={`${css.tableHead} ${css.optional}`}>What Unit Will Hold</th>
                <th className={css.tableHead}>Unit Visualization</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={css.tableData}>
                  <div>5' x 10'</div>
                  <div> 50 sq. ft.</div>
                </td>
                <td className={`${css.tableData} ${css.optional}`}>
                  <div>Pickup Truck or Cargo Van</div>
                  <div>Walk-in Closet</div>
                </td>
                <td className={`${css.tableData} ${css.optional}`}>
                  <p>Mattress set, sofa, dining room set or chest of drawers, boxes and small items</p>
                </td>
                <td className={css.tableData}>
                  <img src={Small} alt="CommunityLockerSS" />
                </td>
              </tr>
              <tr>
                <td className={css.tableData}>
                  <div>10' x 10'</div>
                  <div> 100 sq. ft.</div>
                </td>
                <td className={`${css.tableData} ${css.optional}`}>
                  <div>15' Moving Truck</div>
                  <div>Average Size Bedroom</div>
                </td>
                <td className={`${css.tableData} ${css.optional}`}>
                  <p>Furnishings of one bedroom apartment with refrigerator and washer/dryer, patio furniture and many boxes OR two office suites OR about 200 file boxes</p>
                </td>
                <td className={css.tableData}>
                  <img src={Medium} alt="CommunityLockerSS" />
                </td>
              </tr>
              <tr>
                <td className={css.tableData}>
                  <div>10' x 15'</div>
                  <div> 150 sq. ft.</div>
                </td>
                <td className={`${css.tableData} ${css.optional}`}>
                  <div>20' Moving Truck</div>
                  <div>Large Bedroom</div>
                </td>
                <td className={`${css.tableData} ${css.optional}`}>
                  <p>Furnishings of two bedroom apartment or small house with appliances, patio furniture and many boxes OR a vehicle or small boat OR it is big enough to fit carpet rolls and building materials</p>
                </td>
                <td className={css.tableData}>
                  <img src={Large} alt="CommunityLockerSS" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  )
}

export default StorageTips;
